import { jsx as _jsx } from "react/jsx-runtime";
const Plus = () => (_jsx("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M10 4.16669V15.8334M4.16669 10H15.8334", stroke: "currentColor", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }) }));
export default Plus;
